(ns teamoesterreich.util.helper
  (:require
    [clojure.string :as str]
    [teamoesterreich.util.log :as log :include-macros true]
    [goog.object :as g]
    [goog.string :as string]
    [clojure.walk :as walk]
    )
  )

(defn event-value
  [^js/Event e]
  (-> e (g/get "target") (g/get "value")))


(defn coalesce [& args]
  (reduce (fn [c b] (if (nil? c) b c)) args ))


(defn dissoc-in
  "Dissociates an entry from a nested associative structure returning a new
  nested structure. keys is a sequence of keys. Any empty maps that result
  will not be present in the new structure."
  [m [k & ks :as keys]]
  (if ks
    (if-let [next-map (get m k)]
      (let [new-map (dissoc-in next-map ks)]
        (if (seq new-map)
          (assoc m k new-map)
          (dissoc m k)))
      m)
    (dissoc m k)))


(defn wait-do [!waiting? event-fn & [!loaded?]]
  (fn [e]
    (let [val (event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (when !loaded? (reset! !loaded? false)))
                800)))))


(defn wait-do-select [!waiting? event-fn & [!loaded?]]
  (fn [e]
    (let [val (event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (when !loaded? (reset! !loaded? false)))
                1000)))))


(defn wait-do-check [!waiting? event-fn & [!loaded?]]
  (fn [_ v]
    ;(js/console.log "wait or do" @!waiting? "val" v)
    (event-fn v)
    (when @!waiting? (js/clearTimeout @!waiting?))
    (reset! !waiting?
            (js/setTimeout
              (fn []
                (reset! !waiting? false)
                (when !loaded? (reset! !loaded? false)))
              100))))


(defn update-table-list
  "update-table-list
  Data keys should be keywords
  Use: set :invalidate or :load to trigger
  filter-fn gets cursor
  "
  [!st get-external-data< & [{:keys [filter-fn default-sort default-reverse data-walk-fn]}]]
  (let [post-process-fn (fn [d-list]
                          (let [d-list (if filter-fn (filter-fn d-list !st) d-list)
                                d-list (if-let [sort_ (or (:sort @!st) default-sort)] (sort-by (fn [[k e]]
                                                                                                 ;(js/console.log "sort-by " k ")" sort_ "===" (get e (keyword sort_)) "===  " e)
                                                                                                 (get e (keyword sort_))
                                                                                                 ) d-list) d-list)
                                d-list (if (true? (or (:reverse @!st) default-reverse)) (reverse d-list) d-list)]
                            d-list))]
    ;(js/console.log "load ####  data " (clj->js @!st))
    (if-not (:loaded @!st)
      (get-external-data<
        (fn [data]
          (let [data (if data-walk-fn (walk/walk (fn [[k d]] [k (data-walk-fn d)]) identity data) data)
                d-list (post-process-fn data)]
            ;(js/console.log "got ####  data " (clj->js data))
            (swap! !st assoc
                   :invalidated false
                   :data data
                   :loaded true
                   :count (count d-list)
                   :rows (mapv (fn [[k v]] v) d-list)))))
      )
    (if (:invalidated @!st)
      (let [d-list (post-process-fn (:data @!st))]
        (swap! !st assoc
               :invalidated false
               :count (count d-list)
               :rows (mapv (fn [[k v]] v) d-list))))
    ))



(defn pretty-map [map & [prefix]]
  (str (let [prefix (or prefix " ")]
         (reduce (fn [c [k v]] (str c " " prefix k ": " (if (map? v) (str "\n" (pretty-map v (str prefix " "))) (str "`" v "`")) "\n"))
                 "" map))))




(defn parse-date [date]
  ;(log/debug "parse date" date)
  (js/Date.parse (if date (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)) "01-01-1970")))

(defn date-conv [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  ;(log/debug "date-conv " date)
  (let [d (js/Date. (if (and (not (nil? date)) (> (count (str date)) 12)) (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)) "1970"))
        y (.getFullYear d)
        m (inc (.getMonth d))
        m (if (> m 9) m (str "0" m))
        d (.getDate d)
        d (if (> d 9) d (str "0" d))]
    (str y "-" m "-" d))
  )

(defn datetime-conv [date]
  ;(log/debug "date-conv " date)
  (let [d (js/Date. (if (and (not (nil? date)) (> (count (str date)) 12)) (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)) "1970"))
        y (.getFullYear d)
        m (inc (.getMonth d))
        m (if (> m 9) m (str "0" m))
        d (.getDate d)
        d (if (> d 9) d (str "0" d))

        H (.getHour d)
        i (.getMinute d)
        s (.getSecond d)
        ]
    (str y "-" m "-" d " " H ":" i ": " s))
  )

(defn date-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" "120000.000Z"))

(defn date-ger [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count date) 12)
    (str (subs date 6 8) "." (subs date 4 6) "." (subs date 0 4)
         )
    ""
    ))

(defn date-time-ger [date]
  ;20240517T123544.000Z -> 2021-06-20T23:24
  (if (> (count date) 12)
    (str (subs date 6 8) "." (subs date 4 6) "." (subs date 0 4)
         " " (subs date 9 11) ":"                           ;(subs date 11 13) ":"  (subs date 13 15)
         )
    ""
    ))


(defn date-time-ger-fromT [date]
  (let [date (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8) "T"
                  (subs date 9 11) ":" (subs date 11 13) ":" (subs date 13 15) "Z")
        jsDate (js/Date. date)]
    ;(log/debug "jsDate!!!" jsDate (.toLocaleTimeString jsDate [] #js {:hour "2-digit" :minute "2-digit" }))
    (str (.toLocaleDateString jsDate) " "
         (.toLocaleTimeString jsDate [] #js {:hour "2-digit" :minute "2-digit"}))
    ))
(defn date-ger-fromT [date]
  (let [date (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8) "T"
                  (subs date 9 11) ":" (subs date 11 13) ":" (subs date 13 15) "Z")
        jsDate (js/Date. date)]
    ;(log/debug "jsDate!!!" jsDate (.toLocaleTimeString jsDate [] #js {:hour "2-digit" :minute "2-digit" }))
    (str (.toLocaleDateString jsDate))
    ))
(defn time-ger-fromT [date]
  (let [date (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8) "T"
                  (subs date 9 11) ":" (subs date 11 13) ":" (subs date 13 15) "Z")
        jsDate (js/Date. date)]
    ;(log/debug "jsDate!!!" jsDate (.toLocaleTimeString jsDate [] #js {:hour "2-digit" :minute "2-digit" }))
    (str (.toLocaleTimeString jsDate [] #js {:hour "2-digit" :minute "2-digit"}))
    ))


(defn getTodayDate []
  (let [now (js/Date.)]
    (string/format "%04d%02d%02dT050000.000Z" (.getUTCFullYear now) (inc (.getUTCMonth now)) (.getUTCDate now))
    ))

;(in-ns 'teamoesterreich.util.helper)
;(time-ger-fromT "20180701T100000.000Z")
;(datetime-conv-back "2021-06-20T23:24")

(defn from-timezone-iso [dateTimeT]
  ;20180701T100000.000Z -> 2021-06-20T23:24 localtime
  (if (> (count dateTimeT) 12)
    (str (subs dateTimeT 0 4) "-" (subs dateTimeT 4 6) "-" (subs dateTimeT 6 8) "T" (time-ger-fromT dateTimeT)
         )
    ""
    ))
(defn to-timezone-iso [dateTimeLocal]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (.replaceAll (.replaceAll (.toISOString (js/Date. dateTimeLocal)) "-" "") ":" ""))








